/**
 * Table Loader Component
 *
 * A specialized loader component designed to be used within table rows.
 * It spans multiple columns and displays a centered spinner while data is loading.
 *
 * This provides a consistent loading experience for tables throughout the application.
 *
 * @module components/loader/table-loader
 */

import React from "react";
import { TableRow } from "../common-styling";
import Loader from "./loader";

/**
 * Table loader component that spans across table columns
 *
 * @param {Object} props - Component properties
 * @param {number} props.colSpan - Number of columns to span
 * @param {number} [props.calcHeight=300] - Height calculation for the loader
 * @returns {JSX.Element} Table row with centered loader
 */
const TableLoader = ({ colSpan, calcHeight = 300 }) => {
  return (
    <TableRow>
      <td colSpan={colSpan}>
        {/* Use the standard loader with custom height */}
        <Loader calcHeight={calcHeight} />
      </td>
    </TableRow>
  );
};

export default TableLoader;
